export default __webpack_public_path__ + "static/media/Grid3.6.7f7bcb01.jpg";